// extracted by mini-css-extract-plugin
export var paginationBullet = "index-module--pagination-bullet--9ff4f";
export var paginationBulletActive = "index-module--pagination-bullet-active--58649";
export var paginationHorizontal = "index-module--pagination-horizontal--ed7ae";
export var paginationVertical = "index-module--pagination-vertical--2ddd8";
export var swiperContainer = "index-module--swiper-container--39493";